import { decode } from 'he';
import { isString } from 'lodash';

const decodeString = (input, stripTags = false) => {
  if (isString(input)) {
    return stripTags
      ? decode(input).replace(/(<([^>]+)>)/gi, '')
      : decode(input);
  }

  return input;
};

export default decodeString;
